const importAll = (r: __WebpackModuleApi.RequireContext) => {
  return r.keys().map(r);
}

export const valentineImages = importAll(require.context('@global/assets/valentine', false, /\.(png|jpe?g|svg)$/)) as string[];

export const VALENTINE_CAROUSEL_ANIMATION_MILLISECONDS = 250000;
